import Dexie from 'dexie';
import { CustomerPortal } from 'api/customer-portal/types';
import type {
  Team,
  User,
  Order,
  FormResponseDraft,
  TemplateDraft,
} from 'api/models';
import { TemplateId } from 'data/templates/api';
import {
  Member as MemberModel,
  Team as TeamModel,
  ColumnOrder as ColumnOrderModel,
  FormResponseDraft as FormResponseDraftModel,
  ProjectTemplateDraft as ProjectTemplateDraftModel,
} from './models';
import { CustomerPortalModel } from './models/customer-portal-model';
import {
  LiveCustomerPortal,
  LiveCustomerPortalModel,
} from './models/live-customer-portal';

export const INDEXED_DB_VERSION = 8.1;

export const INDEXED_DB_NAME = 'RktDb';

export class AppDatabase extends Dexie {
  public members!: Dexie.Table<User, number>;

  public teams!: Dexie.Table<Team, number>;

  public columnOrder!: Dexie.Table<Order, string>;

  public formResponseDraft!: Dexie.Table<FormResponseDraft, number>;

  public templateDraft!: Dexie.Table<TemplateDraft, TemplateId>;

  public customerPortal!: Dexie.Table<CustomerPortal, number | 'new'>;

  public liveCustomerPortal!: Dexie.Table<LiveCustomerPortal, 'new'>;

  constructor() {
    super(INDEXED_DB_NAME);

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const db = this;

    // Define tables and indexes
    // https://stackoverflow.com/questions/60087180/with-dexie-can-i-get-all-objects-in-a-table-where-an-array-field-has-a-specific
    db.version(INDEXED_DB_VERSION).stores({
      members: 'userId, userType, userStatus, *projectIds, company.companyId',
      teams: 'teamId, teamName',
      columnOrder: 'key, orderType',
      formResponseDraft: 'formInstance',
      templateDraft: 'templateId',
      customerPortal: 'customerPortalId',
      liveCustomerPortal: 'id',
    });

    db.members.mapToClass(MemberModel);
    db.teams.mapToClass(TeamModel);
    db.columnOrder.mapToClass(ColumnOrderModel);
    db.formResponseDraft.mapToClass(FormResponseDraftModel);
    db.templateDraft.mapToClass(ProjectTemplateDraftModel);
    db.customerPortal.mapToClass(CustomerPortalModel);
    db.liveCustomerPortal.mapToClass(LiveCustomerPortalModel);
  }
}

export const db = new AppDatabase();
